<template>
  <div
    v-if="vbAttachments && vbAttachments.length"
    class="content__message--item"
  >
    <div class="jobInfoAttachment">
      <div
        v-for="vbAttachment in vbAttachments"
        v-bind:key="vbAttachment.id"
        class="file-uploaded input-none__border"
      >
        <div class="file clickable flex-row flex__between padding-0">
          <el-link type="primary" @click="downloadFile(vbAttachment)">
            <file-type-image
              :fileExtention="vbAttachment.fileExtention"
              :customClass="''"
            />
            <span class="">{{ vbAttachment.fileName }}</span>
          </el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buildAttachmentURL from "../../../filters/buildAttachmentURL";
import FileTypeImage from "../../job/FileTypeImage";

export default {
  name: "history-attachments-template-v2",
  components: { FileTypeImage },
  props: ["vbAttachments"],
  filters: { buildAttachmentURL },
  data() {
    return {};
  },

  methods: {
    downloadFile(vbAttachment) {
      this.$emit("downloadFile", { vbAttachment });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/layout/history-attachments-template-v2.vue